import { render, staticRenderFns } from "./name-editor.vue?vue&type=template&id=30b9d5bc&scoped=true"
import script from "./name-editor.vue?vue&type=script&lang=js"
export * from "./name-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b9d5bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30b9d5bc')) {
      api.createRecord('30b9d5bc', component.options)
    } else {
      api.reload('30b9d5bc', component.options)
    }
    module.hot.accept("./name-editor.vue?vue&type=template&id=30b9d5bc&scoped=true", function () {
      api.rerender('30b9d5bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/name-editor.vue"
export default component.exports